import { APIService } from "../../../../../../network/api/APIService";

export const AffiliateJoinData = () => {
    let endpoint = "/affiliate/join/";
    const config = {
        endpoint: endpoint,
        method: "POST",
        credentials: "include",
    };

    return APIService(config);
};